import React from 'react';

import dayjs from 'dayjs';
import 'dayjs/locale/fr';

import { Typography, Card,CardContent} from '@mui/material';

import PostIconStatus from './PostIconStatus';



const ModuleNotification = ({data}) => {

    const st = {
        fontSize: 14, 
        mt:'6px' 
    }

    return (
        <Card sx={{pt:'5px', mt: 3}}>
            <CardContent sx={{display:'flex', justifyContent:'space-between', pb:'0' }}>
                
                <div style={{marginTop:'4px', paddingBottom:0}}><PostIconStatus code={2} /></div>

                <Typography sx={st} color="text.secondary" gutterBottom> Дата сообщения : { dayjs(data.date).format('DD/MM/YYYY HH:mm:ss') } </Typography>
                <Typography sx={st} color="text.secondary" gutterBottom> Язык сообщения : { data.lang } </Typography>
                <Typography sx={st} color="text.secondary" gutterBottom> На мейл : { data.email } </Typography>
                <Typography sx={st} color="text.secondary" gutterBottom> ID сообщения : { data.sended_message_id  } </Typography>
                <Typography sx={st} color="text.secondary" gutterBottom> Тип : { data.type.toUpperCase()  } </Typography>
                
            </CardContent>
        </Card>

    );
}

export default ModuleNotification;
